export default __webpack_public_path__ + "869c50a4fee79d0f1e998fa6cf3092a7.png";